import React from 'react';
import ExperienceComponent from '../components/Experience';

function Experience() {
  return (
    <div className="animate-fade-in-up">
      <ExperienceComponent />
    </div>
  );
}

export default Experience;
